// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accessDeniedBtn {
  height: 55px;
  border-radius: 7px;
  background: #434c63;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #ffffff;
  font-family: "Roboto";
  font-style: normal;
  border: none;
  transition: 0.5s;
  max-width: 490px;
  width: 100%;
}

.accessDeniedBtn:hover {
  background: #373e51;
  cursor: pointer;
  transition: 0.5s;
}

.accessDeniedContainer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 40px;
}

.accessDeniedImage {
  max-width: max-content;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/components/AccessDenied/index.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb","sourcesContent":[".accessDeniedBtn {\r\n  height: 55px;\r\n  border-radius: 7px;\r\n  background: #434c63;\r\n  font-weight: 400;\r\n  font-size: 16px;\r\n  line-height: 19px;\r\n  color: #ffffff;\r\n  font-family: \"Roboto\";\r\n  font-style: normal;\r\n  border: none;\r\n  transition: 0.5s;\r\n  max-width: 490px;\r\n  width: 100%;\r\n}\r\n\r\n.accessDeniedBtn:hover {\r\n  background: #373e51;\r\n  cursor: pointer;\r\n  transition: 0.5s;\r\n}\r\n\r\n.accessDeniedContainer {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 40px;\r\n}\r\n\r\n.accessDeniedImage {\r\n  max-width: max-content;\r\n  width: 100%;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
